import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-06-10T09:53:38-0700.
 */
export function useWorkOrderReportingEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.WorkOrdersReporting, false);

  return Boolean(isEnabled);
}
